export default __webpack_public_path__ + "ecdba4e00f5dadbb87a62a689f9ce7b9.png";